import { useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

export const UserLanguageDropdown = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  // Get current language from i18n (which is now initialized with cookies)
  const currentLang = i18n.language;

  const LANGUAGES = [
    { value: "en", label: "English", icon: "us" },
    { value: "tr", label: "Turkish", icon: "tr" },
    { value: "fr", label: "French", icon: "fr" },
  ];

  const handleLanguageChange = (lang) => {
    Cookies.set("lang", lang.value, { path: "/", expires: 365 });
    i18n.changeLanguage(lang.value);
    setIsOpen(false);
  };

  return (
    <Menu
      as="li"
      className="relative before:rounded-se before:rounded-ss hover:before:content-[''] hover:before:h-[2px] hover:before:w-full hover:before:absolute hover:before:top-0 hover:before:left-0 hover:before:bg-primary"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <MenuButton role="button" className="text-white min-h-[28px] py-1 px-1 rounded text-[12px] flex items-center">
        <i className={`text-white/70 text-[17px] fi fi-${LANGUAGES.find((l) => l.value === currentLang)?.icon}`} />
        {/* <span className="ml-2">{LANGUAGES.find(l => l.value === currentLang)?.label}</span> */}
      </MenuButton>

      {isOpen && (
        <MenuItems
          transition
          anchor="bottom end"
          className="origin-top focus-within:outline-0 bg-[rgb(0,12,36,1)] min-w-[120px] p-2 transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 z-[100]"
        >
          {LANGUAGES.map((item) => (
            <MenuItem
              key={item.value}
              as="button"
              onClick={() => handleLanguageChange(item)}
              className="menu-item-bg-gradiant w-full list-none mt-0.5 pl-3 rounded-[4px] flex cursor-pointer items-center relative before:rounded-tl-lg before:rounded-bl-lg hover:before:h-full hover:before:w-0.5 hover:before:bg-primary hover:before:absolute hover:before:left-0 group"
            >
              <i className={`text-white/70 text-[17px] group-hover:text-white fi fi-${item.icon}`} />
              <span className="flex items-center text-[14px] ml-2 h-[34px] text-white/70 group-hover:text-white">{item.label}</span>
            </MenuItem>
          ))}
        </MenuItems>
      )}
    </Menu>
  );
};
